import { useState, useEffect } from 'react';
import { api } from '../api/client';

export default function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ registration: '', mobileNumber: '' });
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const fetchVehicles = () =>
    api.vehicles.list()
      .then(setVehicles)
      .catch(console.error)
      .finally(() => setLoading(false));

  useEffect(() => { fetchVehicles(); }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({
      ...f,
      [name]: name === 'registration' ? value.toUpperCase() : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess('');
    setSubmitting(true);
    try {
      await api.vehicles.register(form);
      setFormSuccess(`Vehicle ${form.registration.replace(/\s+/g,'').toUpperCase()} registered successfully!`);
      setForm({ registration: '', mobileNumber: '' });
      fetchVehicles();
    } catch (err) {
      setFormError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (id, reg) => {
    if (!window.confirm(`Remove ${reg} from your account?`)) return;
    try {
      await api.vehicles.remove(id);
      setVehicles(v => v.filter(x => x.id !== id));
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">My Vehicles</h1>
        <p className="page-subtitle">Register your vehicle so others can reach you via TxtMyCar</p>
      </div>

      {loading ? (
        <p style={{ color: 'var(--muted)', marginBottom: 32 }}>Loading vehicles…</p>
      ) : vehicles.length === 0 ? (
        <div className="empty-state" style={{ marginBottom: 32 }}>
          <div className="empty-state-icon">������</div>
          <p>No vehicles registered yet. Add one below.</p>
        </div>
      ) : (
        <div className="vehicles-grid">
          {vehicles.map(v => (
            <div key={v.id} className="vehicle-card">
              <div className="vehicle-plate">{v.registration}</div>
              <div className="vehicle-mobile"> {v.mobile_number}</div>
              <div className="vehicle-card-actions">
                <button
                  className="btn btn-danger"
                  onClick={() => handleDelete(v.id, v.registration)}
                  style={{ fontSize: 12 }}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="card" style={{ maxWidth: 480 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 6 }}>Register a vehicle</h2>
        <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 24 }}>
          Enter your UK number plate and the mobile number to receive messages on.
        </p>

        {formError && <div className="alert alert-error">{formError}</div>}
        {formSuccess && <div className="alert alert-success">{formSuccess}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Registration number</label>
            <input
              type="text"
              name="registration"
              value={form.registration}
              onChange={handleChange}
              placeholder="AB12 CDE"
              className="reg-input"
              maxLength={8}
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile number (UK)</label>
            <input
              type="tel"
              name="mobileNumber"
              value={form.mobileNumber}
              onChange={handleChange}
              placeholder="07700 900000"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? <><span className="spinner"></span> Registering…</> : 'Register vehicle'}
          </button>
        </form>
      </div>
    </div>
  );
}
